import { render, staticRenderFns } from "./UserGroupManager.vue?vue&type=template&id=054e2ed0&scoped=true"
import script from "./UserGroupManager.vue?vue&type=script&lang=js"
export * from "./UserGroupManager.vue?vue&type=script&lang=js"
import style0 from "./UserGroupManager.vue?vue&type=style&index=0&id=054e2ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e2ed0",
  null
  
)

export default component.exports